import { render, staticRenderFns } from "./sentenceM10.vue?vue&type=template&id=fbe1267a&scoped=true&"
import script from "./sentenceM10.vue?vue&type=script&lang=js&"
export * from "./sentenceM10.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM10.vue?vue&type=style&index=0&id=fbe1267a&lang=scss&scoped=true&"
import style1 from "./sentenceM10.vue?vue&type=style&index=1&id=fbe1267a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe1267a",
  null
  
)

export default component.exports